<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item :label="navIndex==0?'团队成员：':'客户信息：'">
              <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
                <el-option :label="item.name" :value="item.level" v-for="(item,index) in businessOption" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav"></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column :label="navIndex==0?'团队成员':'客户信息'" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.name }}</span>
                <span style="display: block;">{{ row.pho }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="用友编码" prop="achievement"  align="center" v-if="navIndex"></el-table-column>
          <el-table-column label="总业绩" prop="totalMoney" sortable align="center"></el-table-column>
          <el-table-column label="订货业绩" prop="dinghuoMoney" sortable align="center"></el-table-column>
          <el-table-column label="秒杀业绩" prop="miaoshuaMoney" sortable align="center"></el-table-column>
          <!-- <el-table-column label="充值业绩" prop="czAchievement" sortable="custom" align="center"></el-table-column> -->
          <el-table-column label="学费业绩" prop="xuefeiMoney" sortable align="center"></el-table-column>
          <el-table-column label="课程业绩" prop="kechengMoney" sortable align="center" width="100"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
import Times from '../../components/times.vue'
import Navs from '../../components/navs.vue'
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        totalMoneySortSign:-1
      },
      selectItems: [],
      times: null,
      navList: [
        {name:'团队业绩',id:1},
        {name:'客户业绩',id:2}
      ],
      navIndex: 0,
      businessOption: [],
      today:'',
      id:''
    }
  },
  created() {
    let queryObj = this.$route.query;
    if(queryObj.index) this.navIndex = queryObj.index;
  },
  async mounted() {
    this.$refs.navs.navIndex = this.navIndex*1;
    this.id=this.$route.query.id
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times={
      timeStart:`${this.today} 00:00:00`,
      timeEnd:`${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
    this.getBusinessStanding()
    this.getOption()
    // console.log('arr1',arr1)
    // this.businessOption=[...arr1,...arr2]
  },
  methods: {
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'totalMoney': 'totalMoneySortSign',
        'dinghuoMoney': 'dinghuoMoneySortSign',
        'miaoshuaMoney': 'miaoshuaMoneySortSign',
        'xuefeiMoney': 'xuefeiMoneySortSign',
        'kechengMoney': 'kechengMoneySortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.businessOption.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    // 获取客户
    getOption() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.businessOption.push(...data)
        // console.log('客户身份: ', data);
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 获取时间段
     */
     getTime(event) {
      this.times = JSON.parse(event)
      if(!this.times.ifUse){
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
     handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query={
        pageNo: 1,
        pageSize: 10,
        totalMoneySortSign:-1
      }
      this.times = {
        timeStart:`${this.today} 00:00:00`,
        timeEnd:`${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
        this.navIndex = index;
        this.doQueryList({ pageNo: 1 });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query={...this.query,parentId:this.id}
      query.viewType=this.navList[this.navIndex].id
      if(this.times && this.times.timeStart){
        query.startTime=this.times.timeStart
        query.endTime=this.times.timeEnd
      }
      this.listLoading = true
      return clientListApi.getYeWuStatistics(query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    // changeSwitch(row) {
    //   sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
    //     this.$common.showMsg('success', '操作成功')
    //   })
    // },
    /**
     * 页面跳转
     */
    toPage(path,row,type) {
      if(type) {
        this.$router.push(`${path}?id=${row.id}&index=${type-1}`)
      }else{
        this.$router.push(`${path}?id=${row.id}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .filter-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0;
    .times {
      display: flex;
      align-items: center;
    }
    .btns {
      margin-bottom: 22px;
    }
  }
</style>
